import React from "react";
import {Form} from "react-bootstrap";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import {dispatchBooks} from "./actions/actions";
import axios from "axios";
import {fetch_books, fetch_booklists} from "../Books/action/books";
import UserButton from "./UserButton";

class TopSection extends React.Component{
    constructor(props) {
      super(props);
    
      this.state = {
            data:{
                "searchBar": "",
                "books": [],
                "searchResults": [],
                "searchSuggestions": []
            }
      };
      if(axios.defaults.headers.common.id === localStorage.BookAppLogin){
        this.props.fetch_books().then(data => {
            this.setState({data: {...this.state.data, "books": data.data.books}});
        });
        this.props.fetch_booklists().then(data => {
            this.setState({data: {...this.state.data, "bookLists": data.data.bookLists}});
        });
      };
    };
    onts = e => {
        const {changeResult} = this;
        if(e===""){
            this.setState({data: {...this.state.data, searchBar: "", searchResults:[], searchSuggestions: []}})
            this.dispatchBook({})
        }
        if(e) { 
            console.log(e);
            if(this.state.data.books) {console.log(e); setTimeout(() => {
            this.state.data.books.map(function (item) {
                if(item.book_title.toLowerCase().includes(e.toLowerCase())){
                    changeResult(item);
                }else{
                    // console.log(item.book_title)
                }
                    return "Entried";
            })
        }, 3000)}}
    };
    dispatchBook = e => {
        this.props.dispatchBooks(e);
    };
    changeResult = e => {
        const searchResults = this.state.data.searchResults;
        var push = 0;
        for(var i = 0; i < searchResults.length; i++){
            if(searchResults[i].book_title.toLowerCase() !== e.book_title.toLowerCase()){
                push++;
                console.log(push)
            }
        };
        if(push === searchResults.length){
            searchResults.push(e)
        }
        for(var u = 0; u<searchResults.length; u++){
            if(!searchResults[u].book_title.toLowerCase().includes(this.state.data.searchBar.toLowerCase())){
                searchResults.splice(i);
            }
        }
        this.setState({data:{...this.state.data, searchSuggestions: searchResults, searchResults: searchResults}})
    };
    onchange = event => {
        this.setState({
            data: {...this.state.data, [event.target.name] : event.target.value }
        });
        this.onts(event.target.value)
    };
    emptySearchSug=e=>{
        this.setState({data: {...this.state.data, searchSuggestions: []}})
    };
    keypress = e => {
        const {dispatchBook} = this;
        if(e.key ==='Enter'){
            console.log(this.state.data.searchResults)
            if(this.state.data.searchResults.length !== 0){
                console.log("bok")
            dispatchBook({books: this.state.data.searchResults, length: this.state.data.searchResults.length});
        }
        };
    };
    checkClick = e => {
        if(this.state.data.searchSuggestions !== []){
                document.addEventListener("click", () => {
                    this.emptySearchSug();
                })
        }
    }
    render(){
        const {searchBar, searchSuggestions} = this.state.data;
        const {checkClick} = this;
        return(
            <div className="topSection">
                <h1>My Personal Book Room</h1>
                <Form.Control 
                    type="text" 
                    className="search-bar" 
                    name="searchBar"
                    value={searchBar}
                    onChange={this.onchange}
                    onKeyPress={this.keypress}
                    autoComplete="off"
                    placeholder="Search Your Books Here..."
                />
                <UserButton />
                <div className="searchSuggestions">
                    {searchSuggestions!== [] && searchSuggestions.map(function(item){
                        checkClick();
                        return <SearchSuggestions bookId={item.bookId} book_title={item.book_title}/>
                    })}
                </div>
            </div>
        );
    };
};

const SearchSuggestions = (props) => {
    return (
        <Link to={"/main/books/"+props.bookId}><p>{props.book_title}</p></Link>
    )
}

function mapStateToProps(state){
    return {books: state.AllBooks.books}
}

export default connect(mapStateToProps, {dispatchBooks, fetch_books, fetch_booklists})(TopSection);